import { tv, type VariantProps } from 'tailwind-variants';
export type OrContentMediaBlockVariants = VariantProps<
  typeof orContentMediaBlock
>;

const orContentMediaBlock = tv({
  base: '',
  slots: {
    leftColumn: '',
    rightColumn:
      'md:gap-15 col-span-1 mt-[60px] grid gap-y-12 md:col-span-6 lg:mt-0 lg:gap-12 lg:flex lg:flex-col lg:justify-center',
    media: 'w-full h-full',
  },
  variants: {
    size: {
      sm: {
        leftColumn: 'col-span-1 md:col-span-6 lg:col-span-6',
        rightColumn: 'col-span-1 lg:col-start-8 lg:col-span-5 lg:px-72',
        media: '',
      },
      lg: {
        leftColumn: 'col-span-1 md:col-span-6 lg:col-span-7',
        rightColumn: 'col-span-1 lg:col-start-9 lg:col-span-4 lg:px-7',
        media: '',
      },
    },
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orContentMediaBlock;
